import gql from 'graphql-tag'
import { openingHours, accountingData } from './fragments'

const query = gql`
query getShop($id: ID!) {
	cashAssist {
		getShop(id: $id) {
			id
			mod_ver
			name
			regionId
			timeTrackingToken
			codePrefix
			...openingHours
			...accountingData

			incomeAccount
			cashRegisterAccountDifference
			cashRegisterAccountDifferenceNegative
			tipsAccount
			cashRegisterAccountTransfer
			accountPrepaidCard
			accountPrepaidCardLoad
			accountPrepaidCardDiscount
			savedChartOfAccounts
			qrMenuCashRegisterId
			clickCollectCashRegisterId
			egumaApiKey
			guradoConsumerKey
			guradoConsumerSecret
			axessApiKey
			kitchenMasterClientId
			gruberConfig {
				id
				name
				ip
				crId
				pooling
			}
		}
	}
}
${accountingData}
${openingHours}
`
export default query
